<p-toast [preventDuplicates]="true" [preventOpenDuplicates]="true" />
<p-divider />
<div class="" *ngFor="let prj of proyectoAsignado">
    <div class="card h-full">
        <div class="flex flex-column md:flex-row justify-content-between align-items-center mb-0">
            <div class="flex flex-column text-center md:text-left">
                <span class="text-700 text-2xl mb-2 font-bold">SOLICITUD #{{ proyectoAsignado[0].numeroExpediente }}</span>
                <span class="text-700 text-lg">{{ proyectoAsignado[0].descripcion }}</span>
            </div>
            <div class="p-toolbar-group-end">
                <span class="p-2">
                    <p-button (click)="goBack()" label="Regresar" icon="pi pi-undo text-2xl"
                        styleClass="p-button-rounded ml-2" />
                </span>
            </div>
        </div>
        <p-tabView>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <i class="pi pi-book"></i>
                    <span class="pl-1">Generales</span>
                </ng-template>



                <app-generales-proyecto
                    [rendertitle]="true"
                    [prj]="prj"
                    [isRegistroProfesional]="is_proyect_rp"
                    [hideTitle]="true"
                    [hideDescription]="true">
                </app-generales-proyecto>



            </p-tabPanel>
        </p-tabView>
    </div>
</div>
<p-divider />
<shared-loader class="global-overlay" [hidden]="!_showLoader"></shared-loader>
<p-card *ngIf="this.selected!==null">
    <div>
        <div class="mt-5">
            <p-accordion [activeIndex]="0">
                <p-accordionTab header="Documentos y formularios" class="line-height-3 m-0">
                    <solicitud-requisitos [requisitos]="tramiteService.requisitosFormularios()"
                        [idProyecto]="this.idProyecto!" [idSolicitud]="this.selected!.idSolicitud.toString()!"
                        [idTramite]="this.idTramite" [datosCargados]="tramiteService.datosCargados" [isRp]="is_proyect_rp"
                        (onEventEmitterSelected)="onReceiveTramite($event)"></solicitud-requisitos>

                </p-accordionTab>
            </p-accordion>
        </div>
    </div>
    <div class="p-fluid p-formgrid grid mt-2">
        <div class="field col-12 md:col-9" >
            <ul class="list-none m-0 w-full">
                <li class="flex justify-content-between surface-border py-3" *ngIf="!is_proyect_rp">
                    <span class="text-900 text-4xl font-medium">Total a cancelar por trámite: $ <b>{{ tarifa }}</b>
                    </span>
                </li>
            </ul>
        </div>
        <div class="field col-12 md:col-3">
            <div class="flex justify-content-end gap-2">
               <ng-container *ngIf="!is_proyect_rp">
                    <p-button
                        icon="pi pi-calculator"
                        class="p-button-info p-button-rounded p-button-lg"
                        (click)="onChangeCalcularTarifa()"
                        pTooltip="Calcular tarifa"
                        tooltipPosition="top"
                        styleClass="p-button-icon p-button-info p-button-lg p-button-rounded w-full h-full">
                    </p-button>
                </ng-container>
                <ng-container *ngIf="selected.idEstadoTramite != 5">
                    <!-- ESTE ES -->
                    <p-button
                        label="Proceder a pagar"
                        (click)="completarTramite()"
                        icon="pi pi pi-cart-plus"
                        iconPos="right"
                        [rounded]="true"
                        styleClass="p-button-icon p-button-info text-xl h-full"
                        [disabled]="validacionBotonCompletarTramite()">
                    </p-button>
                </ng-container>
                <ng-container *ngIf="selected.idEstadoTramite == 5">
                    <p-button
                        label="Proceder a pagar"
                        (click)="procesarTramiteSinCosto()"
                        icon="pi pi pi-cart-plus"
                        iconPos="right"
                        [rounded]="true"
                        styleClass="p-button-icon p-button-info text-xl h-full"
                        [disabled]="validacionBotonCompletarTramite()">
                    </p-button>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="p-fluid grid" *ngIf="tramiteService.textTarifa!=''">
        <div class="col-12 align-self-center">
            <small class="text-gray-600">*{{ tramiteService.textTarifa }}</small>
        </div>
    </div>
</p-card>
